/* Grillas del home: revelado de tarjetas y trazo de la regla al entrar a la
   vista (la de la primera grilla la dibuja el hero, por eso queda fuera). */
const { mount, reveal } = window.EQ;
mount('[data-eq-hgrid]', (root) => {
  const r = reveal(root);
  return () => r.destroy();
});
